import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const constApi = {
  sign_in_table: baseAPI + baseUrl + 'config/checkIn/list',
  update_sign_in_table: baseAPI + baseUrl + 'config/checkIn/create',
  clone_sign_in_table: baseAPI + baseUrl + 'config/checkIn/clone',
  delete_sign_in_table: baseAPI + baseUrl + 'config/checkIn/delete',
  sign_in_reward_table: baseAPI + baseUrl + 'config/checkIn/rewardList',
  update_sign_in_reward_table: baseAPI + baseUrl + 'config/checkIn/rewardCreat',
  delete_sign_in_reward_table: baseAPI + baseUrl + 'config/checkIn/rewardDelete',
  time_box_table: baseAPI + baseUrl + 'config/timeBox/list',
  update_time_box_table: baseAPI + baseUrl + 'config/timeBox/create',
  // delete_time_box_table: baseAPI + baseUrl + 'config/timeBox/delete',
  time_box_reward_table: baseAPI + baseUrl + 'config/timeBox/rewardList',
  update_time_box_reward_table: baseAPI + baseUrl + 'config/timeBox/rewardCreat',
  delete_time_box_reward_table: baseAPI + baseUrl + 'config/timeBox/rewardDelete',

  app_config_list: baseAPI + baseUrl + 'config/app_config_award/list',
  app_config_create: baseAPI + baseUrl + 'config/app_config_award/create',
  app_config_update: baseAPI + baseUrl + 'config/app_config_award/update',
  
  // 签到跳转配置
  check_in_jump_list: baseAPI + baseUrl + 'config/check_in/after_jump/list',
  check_in_jump_add: baseAPI + baseUrl + 'config/check_in/after_jump/add',
  check_in_jump_update: baseAPI + baseUrl + 'config/check_in/after_jump/update',
  check_in_jump_change_valid: baseAPI + baseUrl + 'config/check_in/after_jump/change_valid',
  check_in_jump_scene_constant: baseAPI + baseUrl + 'config/check_in/after_jump/scene_constant'
}

// 通用奖品列表
export const getConfigList = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.app_config_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    },
  })
  return res
}
// 通用奖品列表
export const cloneSignData = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.clone_sign_in_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}
// 通用奖品创建
export const createAppConfig = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.app_config_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}
// 通用奖品更新
export const updateAppConfig = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.app_config_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}


// 签到奖励表
export const getSignInTable = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.sign_in_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}

// 编辑奖励表
export const updateSignInTable = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.update_sign_in_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}

// 删除奖励表
export const deleteSignInTable = async (id) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.delete_sign_in_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: { id: id }
  })
  return res
}


// 签到奖励详情表
export const getSignInDetailTable = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.sign_in_reward_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}

// 编辑奖励详情表
export const updateSignInDetailTable = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.update_sign_in_reward_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}

// // 删除奖励表
export const deleteSignInDetailTable = async (id) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.delete_sign_in_reward_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: { id: id }
  })
  return res
}


// 签到奖励表
export const getTimeBoxTable = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.time_box_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}

// 编辑奖励表
export const updateTimeBoxTable = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.update_time_box_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}

// // 删除奖励表
// export const deleteTimeBoxTable = async (id) => {
//   const { data: res } = await service({
//     method: 'post',
//     url: constApi.delete_time_box_table,
//     withCredentials: true,
//     params: {
//       username: store.getters.username,
//       token: store.getters.token,
//     },
//     data: { id: id }
//   })
//   return res
// }


// 签到奖励详情表
export const getTimeBoxDetailTable = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.time_box_reward_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}

// 编辑奖励详情表
export const updateTimeBoxDetailTable = async (queryData) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.update_time_box_reward_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: queryData
  })
  return res
}

// // 删除奖励表
export const deleteTimeBoxDetailTable = async (id) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.delete_time_box_reward_table,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: { id: id }
  })
  return res
}

// 签到跳转配置 - 查询列表
export const getCheckInJumpList = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.check_in_jump_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    },
  })
  return res
}

// 签到跳转配置 - 新增
export const addCheckInJump = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.check_in_jump_add,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 签到跳转配置 - 修改
export const updateCheckInJump = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.check_in_jump_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 签到跳转配置 - 修改状态
export const changeCheckInJumpValid = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.check_in_jump_change_valid,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 签到跳转配置 - 获取场景常量
export const getCheckInJumpSceneConstant = async () => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.check_in_jump_scene_constant,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
  })
  return res
}




